export default "__VITE_ASSET__Ca_6Ddoq__"